import { TeacherOnboardingStepper } from "@/pages/teacher-onboarding/TeacherOnboardingStepper"
import { TeacherOnboardingScoped } from "@/pages/teacher-onboarding/TeacherOnboardingStepperDefinition"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/onboarding/docent-onboarding/")({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <TeacherOnboardingScoped>
      <TeacherOnboardingStepper />
    </TeacherOnboardingScoped>
  )
}
